import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { useTranslation } from "react-i18next";

export default function CookiePolicy() {
  const { t } = useTranslation();

  return (
    <div className="marketing-page min-h-screen flex flex-col bg-gradient-to-br from-background via-background to-primary/5">
      <Navigation />
      
      <main className="flex-1 container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-card rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            {t("cookies.title")}
          </h1>
          
          <p className="text-sm text-muted-foreground mb-8">
            {t("cookies.lastUpdated", { date: new Date().toLocaleDateString() })}
          </p>

          <div className="space-y-6 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.whatAreCookies.title")}</h2>
              <p className="text-muted-foreground leading-relaxed">
                {t("cookies.sections.whatAreCookies.body")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.howWeUse.title")}</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                {t("cookies.sections.howWeUse.intro")}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>{t("cookies.sections.howWeUse.items.signIn")}</li>
                <li>{t("cookies.sections.howWeUse.items.preferences")}</li>
                <li>{t("cookies.sections.howWeUse.items.usage")}</li>
                <li>{t("cookies.sections.howWeUse.items.performance")}</li>
                <li>{t("cookies.sections.howWeUse.items.security")}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.types.title")}</h2>
              
              <div className="space-y-4">
                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">{t("cookies.sections.types.essential.title")}</h3>
                  <p className="text-sm text-muted-foreground">
                    {t("cookies.sections.types.essential.body")}
                  </p>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">{t("cookies.sections.types.performance.title")}</h3>
                  <p className="text-sm text-muted-foreground">
                    {t("cookies.sections.types.performance.body")}
                  </p>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">{t("cookies.sections.types.functional.title")}</h3>
                  <p className="text-sm text-muted-foreground">
                    {t("cookies.sections.types.functional.body")}
                  </p>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">{t("cookies.sections.types.analytics.title")}</h3>
                  <p className="text-sm text-muted-foreground">
                    {t("cookies.sections.types.analytics.body")}
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.thirdParty.title")}</h2>
              <p className="text-muted-foreground leading-relaxed">
                {t("cookies.sections.thirdParty.body")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.managing.title")}</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                {t("cookies.sections.managing.intro")}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>{t("cookies.sections.managing.items.banner")}</li>
                <li>{t("cookies.sections.managing.items.browser")}</li>
                <li>{t("cookies.sections.managing.items.extensions")}</li>
                <li>{t("cookies.sections.managing.items.optOut")}</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mt-3">
                {t("cookies.sections.managing.note")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.retention.title")}</h2>
              <p className="text-muted-foreground leading-relaxed">
                {t("cookies.sections.retention.body")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.updates.title")}</h2>
              <p className="text-muted-foreground leading-relaxed">
                {t("cookies.sections.updates.body")}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">{t("cookies.sections.contact.title")}</h2>
              <p className="text-muted-foreground leading-relaxed">
                {t("cookies.sections.contact.body")}
              </p>
              <div className="mt-3 space-y-1 text-muted-foreground">
                <p>{t("cookies.sections.contact.email")}</p>
                <p>{t("cookies.sections.contact.address")}</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
